import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getQsServer, setQsServer } from 'redux/actions/qsServerActions';
import {
    getPublicStatus,
    setPublicStatus,
} from 'redux/actions/siteSettingsActions';
import Header from 'components/layout/Partials/Header';

import TextFieldGroup from 'components/common/TextFieldGroup';
import { withRouter } from 'react-router-dom';
import Loading from 'components/common/Loading';
import { getQlikApps } from 'redux/actions/qlikActions';
import * as Icon from 'react-feather';
import SelectFieldGroup from 'components/common/SelectFieldGroup';
import AccessDenied from 'components/common/AccessDenied';
import { Theme } from 'utils/Theme';
import { withStyles } from '@material-ui/styles';
import axios from 'axios';
import { ToastsStore } from 'react-toasts';
import AdminLayout from 'components/layout/AdminLayout';
import { Box } from '@material-ui/core';
import Section from 'components/UI/Section';
import { Helmet } from 'react-helmet';

const styles = Theme();

const QLIK_CLIENT = process.env.QLIK_CLIENT;

class QsServer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            hostname: '',
            internalHostname: null,
            prefix: '',
            port: '',
            secure: '',
            app: '',
            externalPrefix: '',
            errors: {},
            qsVersion: null,
            publicAccess: false,
            qsApps: [],
            detailsChanged: false,
            disableSave: true,
            webIntegrationId: null,
            tenantId: null
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        this.props.getPublicStatus();
        this.props.getQlikApps();
    }

    onChange(e) {
        if (e.target.type === 'checkbox') {
            this.setState({ [e.target.name]: e.target.checked });
            if (e.target.name === 'publicAccess') {
                this.props.setPublicStatus({ publicAccess: e.target.checked });
            }
        } else {
            this.setState({ [e.target.name]: e.target.value });

            if (
                e.target.name === 'hostname' ||
                e.target.name === 'internalHostname'
            ) {
                this.setState({ disableSave: true, detailsChanged: true });
            }
        }
    }

    onSubmit(e) {
        e.preventDefault();
        this.saveQsDetails();
    }

    saveQsDetails() {
        const qsServerData = {
            name: this.state.name,
            hostname: this.state.hostname,
            internalHostname: this.state.internalHostname,
            prefix: this.state.prefix,
            port: this.state.port,
            secure: this.state.secure,
            app: this.state.app,
            externalPrefix: this.state.externalPrefix,
        };

        this.props.setQsServer(qsServerData, this.props.history);
    }

    getQlikConnection = () => {
        axios
            .post('/api/qlik/connect', {
                internalHostname: this.state.internalHostname,
                hostname: this.state.hostname,
            })
            .then((res) => {
                this.setState({ qsVersion: res.data.qComponentVersion });
                //this.saveQsDetails();
                this.setState({ disableSave: false });
            })
            .catch(() => {
                ToastsStore.error(
                    `Could not connect to ${
                        this.state.internalHostname || this.state.hostname
                    }`
                );
                this.setState({ disableSave: true });
            });
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors });
        }
        if (nextProps.qsServer.qsServer) {
            const qsServer = nextProps.qsServer.qsServer;
            const {
                name,
                hostname,
                internalHostname,
                prefix,
                port,
                secure,
                app,
                externalPrefix,
            } = qsServer;

            //SET COMPONENT FIELDS STATE
            this.setState({
                name,
                hostname,
                internalHostname,
                prefix,
                port,
                secure,
                app,
                externalPrefix,
            });
        }

        if (nextProps.qlik) {
            if (nextProps.qlik.apps != null) {
                const qsApps = [];
                nextProps.qlik.apps.forEach((app) => {
                    if (app.qMeta.published) {
                        //Only show published Applications
                        qsApps.push({ key: app.qDocId, title: app.qDocName });
                    }
                });
                this.setState({ qsApps });
            }
        }

        if (nextProps.settings) {
            this.setState({ publicAccess: nextProps.publicAccess });
        }
    }

    render() {
        const { isAuthenticated, user } = this.props.auth;
        const { detailsChanged, disableSave } = this.state;
        const { classes, loading, errors } = this.props;

        return (
            <AdminLayout>
                <Helmet>
                    <title>Qlik Sense Server</title>
                </Helmet>
                <Header>
                    <h2 className="c-navbar__title">
                        Qlik Sense Server Settings
                    </h2>
                </Header>
                <Box className="u-m-xsmall">
                    {isAuthenticated && user.role === 'Admin' && loading && (
                        <Loading />
                    )}

                    {isAuthenticated && user.role === 'Admin' && !loading && (
                        <Section>
                            <div className="u-p-small">
                                <div className="o-line">
                                    <span className="c-icon c-icon--large u-mb-small">
                                        <Icon.Server
                                            className={classes.colorPrimary}
                                        />
                                    </span>
                                    <h5 className="u-mb-xsmall">
                                        Qlik Sense Server
                                    </h5>
                                </div>

                                <div>
                                    <p>
                                        Qlik Sense details are required to
                                        define the Qlik engine connection used
                                        to open applications and get objects and
                                        to define where the Qlik Sense client
                                        side software and extensions should be
                                        loaded from.
                                    </p>
                                </div>

                                <div className="c-divider u-mt-small u-mb-medium" />
                                <form noValidate onSubmit={this.onSubmit}>
                                    <div className="row">
                                        <div className={'col-sm-12'}>
                                            <h5 className={'u-text-muted'}>
                                                Visualisation API Connection
                                                Properties
                                            </h5>
                                        </div>
                                        <div className="col-md-6">
                                            <TextFieldGroup
                                                label="Name"
                                                onChange={this.onChange}
                                                value={this.state.name}
                                                name="name"
                                                error={errors.name}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <TextFieldGroup
                                                label="Hostname"
                                                onChange={this.onChange}
                                                value={this.state.hostname}
                                                name="hostname"
                                                error={errors.hostname}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <TextFieldGroup
                                                label="Internal Hostname"
                                                onChange={this.onChange}
                                                value={
                                                    this.state
                                                        .internalHostname || ''
                                                }
                                                name="internalHostname"
                                                error={errors.internalHostname}
                                                info={`leave empty to use the default ${
                                                    this.state.hostname ||
                                                    'hostname'
                                                } for backend api's`}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <SelectFieldGroup
                                                label={'Use Secure HTTPS'}
                                                type={'text'}
                                                onChange={this.onChange}
                                                value={this.state.secure}
                                                name="secure"
                                                options={[
                                                    {
                                                        key: 'YES',
                                                        title: 'YES',
                                                    },
                                                    { key: 'NO', title: 'NO' },
                                                ]}
                                                errors={errors.secure}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <TextFieldGroup
                                                label="Port"
                                                onChange={this.onChange}
                                                value={this.state.port}
                                                name="port"
                                                error={errors.port}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <TextFieldGroup
                                                label="Default Virtual Proxy Prefix"
                                                onChange={this.onChange}
                                                value={this.state.prefix}
                                                name="prefix"
                                                info="use '/' for default or 'proxy'"
                                                error={errors.proxy}
                                            />
                                        </div>

                                        <div
                                            className={
                                                'col-sm-12 c-divider u-mt-small u-mb-small'
                                            }
                                        />
                                        <div className={'col-sm-12'}>
                                            <h5 className={'u-text-muted'}>
                                                Site Public Access
                                            </h5>
                                            <p
                                                className={
                                                    'u-text-muted u-pt-xsmall u-pb-small'
                                                }
                                            >
                                                This will enable users to view
                                                pages with the option
                                                <i className="u-text-muted">
                                                    Public Access
                                                </i>{' '}
                                                enabled without logging in..
                                            </p>
                                        </div>

                                        <div className={'col-md-6'}>
                                            <div className="c-choice c-choice--checkbox u-mt-medium u-p-xsmall">
                                                <input
                                                    className="c-choice__input"
                                                    id="publicAccess"
                                                    name="publicAccess"
                                                    checked={
                                                        this.state
                                                            .publicAccess &&
                                                        'checked'
                                                    }
                                                    onChange={this.onChange}
                                                    type="checkbox"
                                                />
                                                <label
                                                    className="c-choice__label"
                                                    htmlFor="publicAccess"
                                                >
                                                    Enable Public Access
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <TextFieldGroup
                                                label="Public Access Virtual Proxy Prefix"
                                                disabled={
                                                    !this.state.publicAccess
                                                }
                                                onChange={this.onChange}
                                                value={
                                                    this.state.externalPrefix
                                                }
                                                name="prefix"
                                                info="The Authentication access mode for the virtual proxy in Qlik Sense should be set to 'Always Anonymous user'"
                                                error={errors.proxy}
                                            />
                                        </div>

                                        <div
                                            className={
                                                'col-sm-12 c-divider u-mt-small u-mb-small'
                                            }
                                        />
                                        <div className={'col-sm-12'}>
                                            <h5 className={'u-text-muted'}>
                                                Test Hostname and Qlik Sense
                                                Certificates
                                            </h5>
                                        </div>

                                        <div className="col-md-6">
                                            <label className={'u-p-xsmall'}>
                                                {' '}
                                                Status
                                                {this.state.qsVersion !==
                                                null ? (
                                                    <i
                                                        className={
                                                            classes.colorPrimary
                                                        }
                                                    >
                                                        {' '}
                                                        connected v.{' '}
                                                        {
                                                            this.state.qsVersion
                                                        }{' '}
                                                    </i>
                                                ) : (
                                                    <i
                                                        className={
                                                            classes.colorSecondary
                                                        }
                                                    >
                                                        {' '}
                                                        unknown
                                                    </i>
                                                )}
                                            </label>
                                            {this.state.qsVersion !== null &&
                                            !detailsChanged ? (
                                                <span
                                                    type="button"
                                                    disabled={true}
                                                    className={`c-btn c-btn--fullwidth ${classes.buttonSuccess} c-tooltip c-tooltip--top`}
                                                    aria-label="Connected to Qlik Sense Server"
                                                >
                                                    CONNECTED
                                                </span>
                                            ) : (
                                                <span
                                                    className={`c-btn c-btn--fullwidth ${classes.buttonPrimary} c-tooltip c-tooltip--top`}
                                                    aria-label="Test Connection to Qlik Sense Server and Load Applications"
                                                    onClick={
                                                        this.getQlikConnection
                                                    }
                                                >
                                                    CONNECT
                                                </span>
                                            )}
                                        </div>

                                        <div className="col-md-6">
                                            {this.state.qsApps === null ||
                                            this.state.qsApps.length <= 0 ? (
                                                <div>
                                                    <label
                                                        className={'u-p-xsmall'}
                                                    >
                                                        Connect to Server and
                                                        load Qlik Sense Apps.
                                                    </label>
                                                    <button
                                                        disabled={
                                                            this.state
                                                                .qsVersion ===
                                                            null
                                                                ? true
                                                                : false
                                                        }
                                                        className={`u-mb-medium c-btn c-btn--fullwidth ${classes.buttonPrimary}`}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.props.getQlikApps();
                                                        }}
                                                    >
                                                        Load Qlik Sense Apps
                                                    </button>{' '}
                                                </div>
                                            ) : (
                                                <SelectFieldGroup
                                                    className={'u-mt-small'}
                                                    label={'Qlik Sense App'}
                                                    type={'text'}
                                                    onChange={this.onChange}
                                                    value={this.state.app}
                                                    options={this.state.qsApps}
                                                    name={'app'}
                                                    error={errors.app}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="o-line">
                                        <div className="">
                                            <button
                                                onClick={this.onSubmit}
                                                type="submit"
                                                className={`c-btn ${classes.buttonPrimary} has-arrow u-text-center c-tooltip c-tooltip--top`}
                                                aria-label="Save Qlik Sense Server Connection Details"
                                            >
                                                {' '}
                                                Save Details
                                            </button>
                                        </div>
                                        <div className="">
                                            <button
                                                type="button"
                                                onClick={(e) => {
                                                    this.props.history.goBack();
                                                }}
                                                className={`c-btn ${classes.buttonSecondary} has-arrow u-text-center c-tooltip c-tooltip--top`}
                                                aria-label="Back to previous page"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Section>
                    )}

                    {isAuthenticated && user.role !== 'Admin' && !loading && (
                        <AccessDenied
                            props={{ classes, history: this.props.history }}
                        />
                    )}
                </Box>
            </AdminLayout>
        );
    }
}

QsServer.propTypes = {
    auth: PropTypes.object.isRequired,
    setQsServer: PropTypes.func.isRequired,
    getQlikConnection: PropTypes.func,
    getQlikApps: PropTypes.func,
    qsServer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    setPublicStatus: PropTypes.func.isRequired,
    getPublicStatus: PropTypes.func.isRequired,
    history: PropTypes.object,
    qlik: PropTypes.object,
    settings: PropTypes.object,
    classes: PropTypes.object,
    loading: PropTypes.bool,
    publicAccess: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    qsServer: state.qsServer,
    errors: state.errors,
    settings: state.settings,
    publicAccess: state.settings.publicAccess,
    qlik: state.qlik,
});

export default connect(mapStateToProps, {
    setQsServer,
    getQlikApps,
    getPublicStatus,
    setPublicStatus,
})(withRouter(withStyles(styles)(QsServer)));
